import { type OptimizelyDecision } from '@optimizely/optimizely-sdk'

export const FEATURE_FLAG = {
  CLIENT_SIDE_SRP_LOAD: 'kcan-22967_client_side_srp_load',
  CHAMELEON_TRACKING: 'chameleon_tracking',
  PERFORMANCE_LISTING_COUNT: 'kcan_23226_performance_listing_count_toggle',
  CAS_BACKFILL_REDUCTION: 'kcan-22549_reduce_admarkt_backfill',
  PRICE_DROP_NOTIFICATION: 'price_drop_notification',
  HEADER_SIMPLIFIED: 'header_simplified_v2',
  AUTOS_LANDING_PAGE_EXPERIMENT: 'kjca-1941-autos-landing-page-experiment',
  SAVED_SEARCH_WITHIN_FILTERS: 'kjca-3630-saved-search-within-filters',
} as const

export type RuleDecision = {
  isEnabled?: OptimizelyDecision['enabled']
  variationKey: OptimizelyDecision['variationKey']
}

export type FeatureFlag = ValuesType<typeof FEATURE_FLAG>
